import React, { Component } from "react";
import { translations } from "../../../translate.js";
import {
    UncontrolledDropdown,
    Row,
    Col,
    Card,
    CardBody,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalBody,
} from "reactstrap";
import { Button, Drawer } from "@material-ui/core";
import { confirmAlert } from "react-confirm-alert";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Pagination from "react-js-pagination";
import { Picky } from "react-picky";
import "react-picky/dist/picky.css";
import SearchIcon from "@material-ui/icons/Search";
import { toAbsoluteUrl } from "../../../_metronic/index.js";
import { CircularProgress } from "@material-ui/core";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import Switch from "@material-ui/core/Switch";
import PayLimit from "./forms/payLimit";
let Strings =
    localStorage.getItem("LANG") == 1 ? translations.Ar : translations.En;
let today = new Date();
let currentDate =
    today.getFullYear() +
    "-" +
    ("0" + (today.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + today.getDate()).slice(-2);

export default class eFAWATEERcomClasses extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: 0,
            loadingSave: 0,
            limit: 15,
            activePage: 1,
            dataCount: 0,
            searchKey: "",
            errorMsg: "",
            fromDate: currentDate,
            toDate: currentDate,
            data: [],
            distributorList: [],
            distId: [],
            subervisorId: [],
            posId: [],

            debitDateFrom: currentDate,
            debitDateTo: currentDate,
            lastPayDateFrom: currentDate,
            lastPayDateTo: currentDate,
            openleftModal: false,
            modal: false,
            posCode: "",
            posCodeError: "",
            modalData: null,
            serialNumber: "",
            selectedMangerPos: [],
            mangerPos: [],
            openHeader: '',
            defaultPayLimit: '',
        };
    }


    handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === "checkbox" ? target.checked : target.value;
        this.setState(
            {
                [name]: value,
                activePage: 1,
            },
            function () {
                if (name == "filterMode") {
                    this.handleRefresh();
                }
            }
        );
    };

    errorModal = (msg) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui alert-box-view">
                        <div className="mb-3">
                            <span className="alert-delete-icon">!</span>
                        </div>
                        <h5>{msg}</h5>
                        <button
                            type="button"
                            className="btn form-cancel-btn alert-btn-margin ml-2 mr-2"
                            onClick={onClose}
                        >
                            {Strings.Cancel}
                        </button>
                    </div>
                );
            },
        });
    };
    confirmBill2 = (event, id) => {
        event.preventDefault();
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui alert-box-view">
                        <div className="mb-3">
                            <span className="alert-Succsess-icon">!</span>
                        </div>
                        <h5>{Strings["Are you sure ?"]}</h5>
                        <p>{Strings["You want to confirm this ?"]}</p>
                        <button
                            type="button"
                            className="btn form-cancel-btn alert-btn-margin ml-2 mr-2"
                            onClick={onClose}
                        >
                            {Strings.Cancel}
                        </button>
                        <button
                            type="button"
                            className="btn form-save-btn"
                            onClick={() => {
                                this.confirmBillHandler2(id);
                                onClose();
                            }}
                        >
                            {Strings.Yes}
                        </button>
                    </div>
                );
            },
        });
    };

    handleRefresh = () => {
        this.setState({
            searchKey: "",
            activePage: 1,
            defaultPayLimit: '',
        }, function () {
            this.getData();
        });
    };


    handleSearch = async () => {
        try {
            this.setState({ loading: 1 });
            const body = {
                type: "getEfwatercomCategoriesForAdmin",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                page: this.state.activePage,
                limit: this.state.limit,
                code: this.state.searchKey,
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data !== "Nothing found") {
                if (data.logout === 1) {
                    localStorage.setItem("USER_ID", "");
                    localStorage.setItem("USER_TOKEN", "");
                    window.location.href = "/logout";
                } else {
                    this.setState({
                        loading: 0,
                        data: data.efwatercomList,
                        dataCount: data?.count
                    });
                }
            } else {
                this.setState({
                    loading: 0,
                    data: [],
                    dataCount: 0
                });
            }
        } catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
        finally {
            this.setState({ loading: 0, loadingSave: 0 });
        }

    };

    componentDidMount() {
        // this.handleSearch();
        this.getData();
    }

    getData = async () => {
        try {
            this.setState({ loading: 1 });
            const body = {
                type: "getEfwatercomCategoriesForAdmin",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                page: this.state.activePage,
                limit: this.state.limit
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data !== "Nothing found") {
                if (data.logout === 1) {
                    localStorage.setItem("USER_ID", "");
                    localStorage.setItem("USER_TOKEN", "");
                    window.location.href = "/logout";
                } else {
                    this.setState({
                        loading: 0,
                        data: data.efwatercomList,
                        dataCount: data?.count
                    });
                }
            } else {
                this.setState({
                    loading: 0,
                    data: [],
                    dataCount: 0
                });
            }
        } catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
        finally {
            this.setState({ loading: 0, loadingSave: 0 });
        }
    }

    handlePageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber }, function () {
            if (this.state.searchKey) {
                this.handleSearch();
            } else {
                this.getData();
            }
        });
    };
    handleChangeStatus = async (event, field, id) => {
        this.setState({ loading: 1 });
        try {

            const body = {
                type: "activateEfwatercomCategories",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                id: id,
                status: event.target.checked ? 1 : 0,
                updateType: 1
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data.logout === 1) {
                localStorage.setItem("USER_ID", "");
                localStorage.setItem("USER_TOKEN", "");
                window.location.href = "/logout";
            } else {
                this.getData();
                this.setState({ loading: 0 });
            }

        } catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
    };
    handleRefreshAllCard = async () => {
        this.setState({ loading: 1 });
        try {
            const body = {
                type: "addEfwatercomCategories",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN")
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });
            const data = await response.json();
            if (data.logout === 1) {
                localStorage.setItem("USER_ID", "");
                localStorage.setItem("USER_TOKEN", "");
                window.location.href = "/logout";
            } else {
                this.getData();
                this.setState({ loading: 0 });
            }

        } catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
    }
    handleUpdateAllCard = async () => {
        this.setState({ loading: 1 });
        try {
            const body = {
                type: "updateEfwatercomCatForPos",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN")
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });
            const data = await response.json();
            if (data.logout == 1) {
                localStorage.setItem("USER_ID", "");
                localStorage.setItem("USER_TOKEN", "");
                window.location.href = "/logout";
            } else {
                this.getData();
                this.setState({ loading: 0 });
            }

        } catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
    }

    handleSaveDefaultPayLimit = async () => {
        this.setState({ loading: 1 });
        try {

            const body = {
                type: "activateEfwatercomCategories",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                updateType: 3,
                payLimit: this.state.defaultPayLimit
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data.logout === 1) {
                localStorage.setItem("USER_ID", "");
                localStorage.setItem("USER_TOKEN", "");
                window.location.href = "/logout";
            } else {
                this.getData();
                this.setState({ loading: 0, defaultPayLimit: '' });
            }

        } catch (error) {
            console.log(error);
            this.setState({ loading: 0 });
        }
    }

    openHeaderMenu = (id) => {
        const val = this.state.openHeader == id ? '' : id;
        this.setState({
            openHeader: val,
        });
    }

    openSidebarModal = (rowData) => {
        this.setState({
            modalData: rowData,
            openleftModal: true
        })
    }

    closeSidebarModal = () => {
        this.setState({
            openleftModal: false,
            modalData: null,
        })
        this.handleSearch();
    }

    render() {
        return (
            <div>

                <Row>
                    <Col lg={12} className="main-color-1 inv-class-view-title mb-4">
                        <div>

                            {Strings["E-fawatercom Classes"]}

                        </div>
                        <hr className="inv-hr-view-2" />
                    </Col>
                </Row>
                <Row className="page-filter-view">
                    <Col
                        xl={{ size: 9, order: 1 }}
                        lg={{ size: 9, order: 1 }}
                        md={{ size: 9, order: 1 }}
                        sm={{ size: 12, order: 1 }}
                        xs={{ size: 12, order: 1 }}
                    >
                        <AvForm ref={(c) => (this.form = c)}>
                            <Row>
                                <Col sm={5} xs={12} md={5} lg={5}>
                                    <AvField
                                        name="searchKey"
                                        type="text"
                                        placeholder={Strings["Search"]}
                                        value={this.state.searchKey}
                                        onChange={(event) => {
                                            this.setState({ searchKey: event.target.value });
                                        }}
                                    />

                                </Col>
                                <Col sm={2} xs={12} md={2} lg={2} className="mt-0">
                                    <button
                                        variant="contained"
                                        className="btn form-save-btn mt-0"
                                        onClick={(event) => {
                                            this.setState({ activePage: 1 }, function () {
                                                this.handleSearch();
                                            })
                                        }}
                                    >
                                        {Strings["Search"]}{" "}
                                        <SearchIcon className="font-size-15  main-color-2" />
                                    </button>
                                </Col>

                            </Row>
                            <Row>
                                <Col sm={5} xs={12} md={5} lg={5}>
                                    <label className="form-label">{Strings["Default Pay Limit"]}</label>
                                    <AvField
                                        name="defaultPayLimit"
                                        type="number"
                                        placeholder={Strings["Enter Default Pay Limit"]}
                                        value={this.state.defaultPayLimit}
                                        onChange={(event) => {
                                            if (event.target.value.length > 0) {
                                                this.setState({ defaultPayLimit: event.target.value });
                                            } else {
                                                this.setState({ defaultPayLimit: '' });
                                            }
                                        }}
                                        min={0.00001}
                                    />

                                </Col>
                                <Col sm={2} xs={12} md={2} lg={2} className="mt-4">
                                    <button
                                        variant="contained"
                                        className="btn form-save-btn mt-2"
                                        onClick={(event) => {
                                            const value = parseFloat(this.state.defaultPayLimit);
                                            if (!this.state.defaultPayLimit || this.state.defaultPayLimit.trim() === '' || isNaN(value) || value < 0.00001) {
                                                return;
                                            }
                                            this.handleSaveDefaultPayLimit();
                                        }}
                                    >
                                        {Strings["Save"]}{" "}
                                        {/* <SearchIcon className="font-size-15  main-color-2" /> */}
                                    </button>
                                </Col>

                            </Row>
                        </AvForm>
                    </Col>

                    <Col
                        xl={{ size: 3, order: 12 }}
                        lg={{ size: 3, order: 12 }}
                        md={{ size: 3, order: 12 }}
                        sm={{ size: 12, order: 12 }}
                        xs={{ size: 12, order: 12 }}
                        className="text-right mb-3  d-flex flex-column align-items-end gap-3 w-100"
                    >


                        <Col sm={12} xs={12} md={10} lg={10}>
                            <button
                                className="btn gradient-button-view gradient-button gradient-button-font-12 m-1 w-100"
                                onClick={
                                    () => this.handleRefreshAllCard()
                                }
                            >
                                {Strings["Update e-fawatercom Cards"]}
                            </button>

                            <button
                                value={this.state.allCkecked == 0 ? "0" : "1"}
                                className="btn page-action-btn m-1 mt-2 w-100"
                                onClick={() => this.handleUpdateAllCard()}
                            >

                                {Strings["Enable POS Cards"]}
                            </button>
                        </Col>
                        <Col sm={12} xs={12} md={5} lg={5}>
                            <Button
                                variant="contained"
                                className="refresh-action-btn"
                                onClick={this.handleRefresh}
                                title={Strings["Refresh"]}
                                style={{ marginTop: "10px" }}
                            >
                                <i className="flaticon-refresh reset-filter-btn"></i>
                            </Button>
                        </Col>

                    </Col>
                </Row>
                {this.state.loading == 0 && this.state.errorMsg != "" && (
                    <Row>
                        <div className="inv-cards-view pb-5 width-100">
                            <div
                                className="text-center"
                                style={{ marginTop: "15%", marginBottom: "15%" }}
                            >
                                <img
                                    alt="Logo"
                                    src={toAbsoluteUrl(
                                        "/media/ezpay/EZPAY_LOGO_GRAY" + window.MAIN_IMAGE + ".png"
                                    )}
                                    className="img-fluid no-data-img"
                                />
                                <div className="no-data-text">{this.state.errorMsg}</div>
                            </div>
                        </div>
                    </Row>
                )}
                {this.state.loading == 0 &&
                    this.state.data.length <= 0 &&
                    this.state.errorMsg == "" && (
                        <Row>
                            <div className="inv-cards-view pb-5 width-100">
                                <div
                                    className="text-center"
                                    style={{ marginTop: "15%", marginBottom: "15%" }}
                                >
                                    <img
                                        alt="Logo"
                                        src={toAbsoluteUrl(
                                            "/media/ezpay/EZPAY_LOGO_GRAY" +
                                            window.MAIN_IMAGE +
                                            ".png"
                                        )}
                                        className="img-fluid no-data-img"
                                    />
                                    <div className="no-data-text">
                                        {Strings["There is no data to display"]}
                                    </div>
                                </div>
                            </div>
                        </Row>
                    )}
                {this.state.loading == 1 && (
                    <Row>
                        <Col lg={12} style={{ marginTop: "7%" }} className="text-center">
                            <div className="card-body">
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-1"
                                    role="status"
                                ></div>
                                <div
                                    className="spinner-grow text-dark m-2 main-color-2"
                                    role="status"
                                ></div>
                            </div>
                        </Col>
                    </Row>
                )}
                {this.state.loading == 0 && this.state.data.length > 0 && (
                    <Row>
                        <div className="inv-cards-view width-100">
                            <Row className="table-header-row d-none d-lg-flex d-md-flex">
                                <Col
                                    lg={2}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Point name"]}
                                >
                                    {Strings["ID"]}
                                </Col>
                                <Col
                                    lg={2}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Total withdrawn profits"]}
                                >
                                    {Strings["Code"]}
                                </Col>
                                <Col
                                    lg={3}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Class Name"]}
                                >
                                    {Strings["Class Name"]}
                                </Col>
                                <Col
                                    lg={2}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Payment Limit"]}
                                >
                                    {Strings["Payment Limit"]}
                                </Col>
                                <Col
                                    lg={2}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length"
                                    title={Strings["Status"]}
                                >
                                    {Strings["Status"]}
                                </Col>
                                <Col
                                    lg={1}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="overflow-text-length text-center"
                                    title={Strings["Action"]}
                                >
                                    {Strings["Action"]}
                                </Col>


                            </Row>
                            {this.state.data.map((rowData, index) => {
                                return (
                                    <Row key={index} className="table-body-row">
                                        <Col
                                            lg={2}
                                            md={12}
                                            sm={3}
                                            xs={12}
                                            className="overflow-text-length  order-2 order-md-1 order-lg-1 "
                                            title={Strings["ID"]}
                                        >

                                            {rowData.id}
                                        </Col>
                                        <Col
                                            lg={2}
                                            md={12}
                                            sm={3}
                                            xs={12}
                                            className="overflow-text-length order-3 order-md-2 order-lg-2"
                                            title={Strings["Code"]}
                                        >

                                            {rowData.code}
                                        </Col>
                                        <Col
                                            lg={3}
                                            md={12}
                                            sm={3}
                                            xs={12}
                                            className="overflow-text-length order-1 order-md-3 order-lg-3 text-bold-ssm"
                                            title={Strings["Class Name"]}
                                        >

                                            {rowData.catName}
                                        </Col>
                                        <Col
                                            lg={2}
                                            md={12}
                                            sm={3}
                                            xs={12}
                                            className="overflow-text-length order-1 order-md-3 order-lg-3 text-bold-ssm"
                                            title={Strings["Payment Limit"]}
                                        >

                                            {rowData.payLimit}
                                        </Col>


                                        <Col
                                            lg={2}
                                            md={12}
                                            sm={3}
                                            xs={12}
                                            className="overflow-text-length order-4 order-md-4 order-lg-4 "
                                            title={Strings["Status"]}
                                        >
                                            <div className="">

                                                <Switch
                                                    checked={rowData["status"] == 1 ? true : false}
                                                    onChange={(event) =>
                                                        this.handleChangeStatus(
                                                            event,
                                                            "status",
                                                            rowData["id"]
                                                        )
                                                    }
                                                    name="status"
                                                    inputProps={{ "aria-label": "secondary checkbox" }}
                                                    size={"small"}
                                                />
                                            </div>
                                        </Col>
                                        <Col
                                            lg={1}
                                            md={1}
                                            sm={1}
                                            xs={12}
                                            className="text-center action-icon-view actionDropdownList order-5 order-md-5 order-lg-5"
                                            title={Strings["Action"]}

                                        >
                                            <Dropdown
                                                isOpen={this.state.openHeader == rowData["id"] ? true : false}
                                                toggle={() => this.openHeaderMenu(rowData["id"])}
                                                className="font-size-13 actionDropdownList"
                                            >
                                                <DropdownToggle
                                                    tag="action"
                                                    className="nav-link pt-0 actionDropdownList"
                                                    caret
                                                >
                                                    <MoreVertIcon
                                                        className="menu-dots-vertical actionDropdownList"
                                                    />
                                                </DropdownToggle>
                                                <DropdownMenu className="font-size-13 actionDropdownList">
                                                    <div
                                                        className="actionDropdownList"
                                                        style={{ maxHeight: "250px", overflowY: "scroll" }}
                                                    >
                                                        <DropdownItem
                                                            className="actionDropdownList"
                                                            onClick={(event) => this.openSidebarModal(rowData)}
                                                        >
                                                            {Strings["Edit"]}
                                                        </DropdownItem>
                                                    </div>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </Col>

                                    </Row>
                                );
                            })}
                            {this.state.loading == 0 && this.state.data?.length > 1 && (
                                <Col md={12}>
                                    <Row className="pagenation-view mt-3 mb-4">
                                        <Pagination
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.dataCount}
                                            pageRangeDisplayed={4}
                                            onChange={this.handlePageChange}
                                            prevPageText={
                                                <i
                                                    className={
                                                        localStorage.getItem("LANG") == 1
                                                            ? "flaticon2-next"
                                                            : "flaticon2-back"
                                                    }
                                                ></i>
                                            }
                                            nextPageText={
                                                <i
                                                    className={
                                                        localStorage.getItem("LANG") == 1
                                                            ? "flaticon2-back"
                                                            : "flaticon2-next"
                                                    }
                                                ></i>
                                            }
                                            hideFirstLastPages
                                            innerClass={
                                                "pagination  pagination-rounded justify-content-end pagenation-view my-2"
                                            }
                                            itemClass={"page-item"}
                                            linkClass={"page-link"}
                                        />
                                    </Row>
                                </Col>
                            )}
                        </div>
                    </Row>
                )}

                <Drawer
                    anchor={localStorage.getItem("LANG") == 1 ? "left" : "right"}
                    open={this.state.openleftModal}
                    className="sidebar-modal-view"
                >
                    {this.state.openleftModal && (
                        <PayLimit
                            rowData={this.state.modalData}
                            close={this.closeSidebarModal}
                        />
                    )}
                </Drawer>


            </div>
        );
    }
}
